
import { ChefHat } from "lucide-react";

const Hero = () => {
  return (
    <div className="pt-16 pb-12 space-y-6 animate-fade-in">
      <div className="flex flex-col md:flex-row items-center justify-center gap-3 mb-4 text-center">
        <ChefHat className="w-16 h-16 text-primary" />
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 tracking-tight text-center">
          Airfryer Recipe Converter
        </h1>
      </div>
      <div className="space-y-2 max-w-3xl mx-auto text-center">
        <h2 className="text-3xl font-semibold text-gray-800">
          Turn Any Recipe into an Airfryer Masterpiece
        </h2>
        <p className="text-xl text-gray-600 leading-relaxed">
          Paste a recipe URL or text, and let AI make it airfryer-perfect.
        </p>
      </div>
    </div>
  );
};

export default Hero;
